<template>
    <div id="rate-cards">
        <!-- <div id="destination-circles">
            <! - <div class="circle top">
                <div class="icon"><md-icon>delete</md-icon></div>
                <div class="label">Never</div>
            </div> -- >
            <div class="circle left">
                <div class="icon"><md-icon>snooze</md-icon></div>
                <div class="label">Not yet</div>
            </div>
            <div class="circle bottom">
                <div class="icon"><md-icon>help</md-icon></div>
                <div class="label">Maybe</div>
            </div>
            <div class="circle right">
                <div class="icon"><md-icon>favorite</md-icon></div>
                <div class="label">Yes!</div>
            </div>
        </div> -->
        <div id="card-stack">
            <IdeaCard
                v-for="(card, index) in cards"
                :key="card._id"
                :title="card.text"
                :subtitle="card.stat || card['stat-' + genderId]"
                :is-current="index === 0"
                @cardAccepted="rateLove"
                @cardRejected="rateNotYet"
                @cardMaybe="rateMaybe"
            ></IdeaCard>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import IdeaCard from '@/components/IdeaCard.vue'
import api from '@/services/api'
import { take } from 'rxjs/operators'

// import Vue from 'vue'
export default {
    name: 'Home',
    data() {
        return {
            cards: [
                // 'He arrives home for work. You wait in sexy lingerie and tell him you need is his cock in you NOW.',
                // 'He wakes you up in the morning by pleasuring you orally.',
                // 'You wake him up in the morning by giving him a blowjob.',
                // 'four',
                // 'five',
                // 'six',
            ],
            genderId: undefined
        }
    },
    async created() {
        this.user = await api.user.pipe(take(1)).toPromise();
        this.addCards()
    },
    components: {
        IdeaCard,
    },
    methods: {
        removeCardFromDeck() {
            this.cards.shift()
            if (this.cards.length <= 3) {
                this.addCards()
            }
        },
        async addCards() {
            if (this.doNotLoadMoreCards) {
                return
            }
            const a = await api.socket
            // a.channel
            a.on('users patched', msg => {
                console.log('msg', msg);
            });
            const data = await api.service('idea-cards').get('unrated');
            // const data = await api.request('get', 'idea-cards/unrated')
            if (data.length <= 3) {
                this.doNotLoadMoreCards = true
            }
            const payload = await api.jwtPayload.pipe(take(1)).toPromise()
            this.genderId = payload.g === 'f' ? 'her' : 'him'
            for (const card of data) {
                const text = card[this.genderId]
                if (!this.cards.find(someCard => someCard._id === card._id)) {
                    this.cards.push({
                        ...card,
                        _id: card._id,
                        text,
                    })
                }
            }
        },
        async rate(rating) {
            const ratedCards = this.user.ratedCards ? this.user.ratedCards.length : 0;
            console.log(this.user, ratedCards)
            this.user = await api.request('PATCH', 'users/me', {
                // ratedCards: [],
                $push: {
                    ratedCards: {
                        id: 'id:' + this.cards[0]._id,
                        rating,
                        date: ratedCards <= 20 ? new Date(0) : new Date()
                    },
                },
            })
            api.user.next(this.user);
            console.log('finished updating')
            this.removeCardFromDeck()
        },
        async rateLove() {
            this.rate(2)
        },
        async rateNotYet() {
            console.log('not yet');
            this.rate(0)
        },
        async rateNever() {
            this.rate(-1)
        },
        async rateMaybe() {
            this.rate(1)
        },
    },
}
</script>

<style lang="less" scoped>
#rate-cards {
    position: relative;
    overflow: hidden;
}
#card-stack {
    width: 85vw;
    position: relative;
    margin: 10vw 7.5vw;
}
// #destination-circles {
//     .circle {
//         background: rgba(255, 255, 255, 0.01);
//         width: 100vw;
//         height: 100vw;
//         border-radius: 50vw;
//         position: absolute;
//         transition: 0.1s linear transform, 0.1s linear background-color;
//         &:hover {
//             background: rgba(255, 255, 255, 0.03);
//             .label {
//                 opacity: 1;
//                 color: rgba(255, 255, 255, 0.2);
//             }
//         }
//         .icon,
//         .label {
//             position: absolute;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             bottom: 0;
//             left: 0;
//             right: 0;
//             top: 0;
//             height: 10vw;
//             width: 10vw;
//             pointer-events: none;
//         }
//         .label {
//             height: 19vw;
//             width: 19vw;
//             font-size: 0.8em;
//             opacity: 0;
//             transition: 0.1s linear color, 0.1s linear opacity;
//             transition-delay: 0.8s, 0s;
//             color: rgba(255, 255, 255, 0);
//             opacity: 0;
//             text-transform: uppercase;
//         }
//     }
//     .circle.left,
//     .circle.right {
//         top: calc(50vh - 50vw);
//     }
//     .circle.top {
//         top: -90vw;
//         .icon,
//         .label {
//             width: unset;
//             top: unset;
//         }
//         &:hover {
//             transform: scale(1.3) translateY(-7vw);
//         }
//     }
//     .circle.left {
//         left: -90vw;
//         .icon,
//         .label {
//             height: unset;
//             left: unset;
//         }
//         .label {
//             transform: rotate(-90deg);
//         }
//         &:hover {
//             transform: scale(1.3) translateX(-7vw);
//         }
//     }
//     .circle.right {
//         right: -90vw;
//         .icon,
//         .label {
//             height: unset;
//             right: unset;
//         }
//         .label {
//             transform: rotate(90deg);
//         }
//         &:hover {
//             transform: scale(1.3) translateX(7vw);
//         }
//     }
//     .circle.bottom {
//         bottom: -90vw;
//         .icon,
//         .label {
//             width: unset;
//             bottom: unset;
//         }
//         &:hover {
//             transform: scale(1.3) translateY(7vw);
//         }
//     }
// }
// #destination-circle-icons {
//     .icon {
//         position: absolute;
//         display: flex;
//         justify-content: center;
//         justify-items: center;
//         opacity: 0.4;
//         color: black;
//         pointer-events: none;
//     }
//     .icon > * {
//         height: 10vw;
//         width: 10vw;
//     }
//     .icon > .emoji {
//         line-height: 10vw;
//         font-size: 1.5em;
//         text-align: center;
//     }
//     .icon.top,
//     .icon.bottom {
//         left: 0;
//         right: 0;
//     }
//     .icon.bottom {
//         bottom: 0;
//     }
//     .icon.left,
//     .icon.right {
//         height: 100vw;
//     }
//     .icon.right {
//         right: 0;
//     }
// }
</style>
<style lang="less">
// #destination-circles .circle {
//     .icon i {
//         color: rgba(0, 0, 0, 0.2);
//         transition: 0.1s linear color;
//     }
//     &:hover .icon i {
//         color: rgba(0, 0, 0, 0.3);
//     }
// }
</style>
